import React from "react";
import styles from "./AssessmentReportsCard.module.css";

const AssessmentReportsCard = ({
  observations = 0,
  concerns = 0,
  reflections = 0,
  filters = [],
}) => {
  const getClass = (value) =>
    value > 0 ? `${styles.item} ${styles.active}` : styles.item;

  return (
    <div className={styles.container}>
      {(filters.length === 0 || filters.includes("Observations")) && (
        <div className={getClass(observations)}>
          <span className={`${styles.dot} ${styles.observation}`}></span>
          <span>{observations} Observations</span>
        </div>
      )}

      {(filters.length === 0 || filters.includes("Concerns")) && (
        <div className={getClass(concerns)}>
          <span className={`${styles.dot} ${styles.concern}`}></span>
          <span>{concerns} Concerns</span>
        </div>
      )}

      {(filters.length === 0 || filters.includes("Reflections")) && (
        <div className={getClass(reflections)}>
          <span className={`${styles.dot} ${styles.reflection}`}></span>
          <span>{reflections} Reflections</span>
        </div>
      )}
    </div>
  );
};

export default AssessmentReportsCard;
